import React from 'react';

import { IImageWith7030TextFields } from '../../../types/contentful';

import { getImageData } from '../../utils/contentful';

import { Text } from '../Text';
import { Box } from '../Box';
import RichText from '../RichText';
import { BlockContainer, Column } from '../Layout';

import {
  Layout7030,
  StyledImage,
  ImageWrapper,
  TextWrapper,
  ColumnContainer
} from './styles';

export function ImageWith7030Text({
  headingText,
  image,
  bodyCopy,
  imageFirst
}: IImageWith7030TextFields) {
  return (
    <BlockContainer
      marginTop={{ 0: 'l', tablet: 'blockMarginY_tablet', desktop: 'm' }}
      marginBottom={{
        0: 'blockMarginY',
        mobile: 's',
        tablet: 'blockMarginY_tablet'
      }}
      data-blockid="imageWith7030Text"
      data-testid="imageWith7030Text"
    >
      <Layout7030
        gutter={{ 0: 'ml', desktop: 'xl' }}
        flexWrap="wrap"
        alignItems="center"
        imageFirst={imageFirst ?? false}
      >
        <Column size={{ 0: 12, tablet: 7, desktop: 6 }}>
          <ImageWrapper>
            <StyledImage
              {...getImageData(image)}
              data-blockid="imageWith7030Text-image"
            />
          </ImageWrapper>
        </Column>
        <ColumnContainer size={{ 0: 10, tablet: 4, desktop: 3 }}>
          <TextWrapper>
            <Box marginBottom={{ 0: 'sm' }} paddingTop={{ 0: 0, tablet: 'm' }}>
              <Text
                as="h2"
                fontWeight={{ 0: 'h2' }}
                fontSize={{ 0: 'h2_0', desktop: 'h2_desktop' }}
                data-blockid="imageWith7030Text-headline"
              >
                {headingText}
              </Text>
            </Box>
            {bodyCopy && (
              <Box
                marginBottom={{ 0: 'ml' }}
                data-blockid="imageWith7030Text-subhead"
              >
                <RichText data={bodyCopy} />
              </Box>
            )}
          </TextWrapper>
        </ColumnContainer>
      </Layout7030>
    </BlockContainer>
  );
}
